import { Component } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { FiltersM } from '../../../components/models';
import { Header } from '../../../components/contenedor-elementos/interfaces/header.interface';
import { ServiciosRiegosService } from '../../../services/riesgo-liquidez/servicios-riegos.service';
import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';
import { TableroService } from '../../../shared/GenerateTabla/services/tablero.service';
import { TemplateLoaderService } from '../../../shared/GenerateTabla/plantillas/template-loader.service';
import { table } from '../../../shared/GenerateTabla/plantillas/models.model';
import { companiesRiesgoLiquidez } from '../../../shared/catalogos';
import { CommonVariables } from '../../funciones/funcionesGenerales';
import { messages } from '../../funciones/mensajes';
import { Aligment, ExcelService, FormatText, TypeRow } from '../../../services/excel/excel.service';

@Component({
  selector: 'app-razones-liquidez',
  templateUrl: './razones-liquidez.component.html',
  styleUrl: './razones-liquidez.component.css'
})
export class RazonesLiquidezComponent {
  /**
   * Variables de filtros
  */
  Filters = FiltersM; 
  /**
   * Variables de intitución y plantillas
   */
  idInst;
  idAdmin;
  private idPlantilla = 7;
  /**
   * Variables de filtros
   */
  periodos = [];
  private numEvaluaciones = 1;
  cadenaEvaluacion = [];
  /** 
   * Configuración titulo
   */
  header: Header = {
    title: ''
  }
  /**
   * Variables de las tablas
   */
  tablaConfig: table;
  verTabla = false;

  perspectivas = [
    {nombre: 'Prueba ácida', name: 'acida', check: true},
    {nombre: 'Razón liquidez ajustada', name: 'ajustada', check: false},
    {nombre: 'Prueba de estrés', name: 'estres', check: false},
  ]  

  constructor(
    readonly dataService: DataService,
    private service: ServiciosRiegosService,
    private cookieService: CookieService,
    private translate: TranslateService,
    private tableroService: TableroService,
    private readonly templateLoader: TemplateLoaderService,

    private readonly excelService: ExcelService,
  ){
    this.idInst = this.cookieService.get('idInstitucion');
    this.idAdmin = companiesRiesgoLiquidez.find(c => c.id === this.idInst)?.idAdmin ?? '';
    var instAT = companiesRiesgoLiquidez.find(c => c.id === this.idInst);
    this.idPlantilla = instAT.idPlantilla;
    this.getEvaluaciones();
  }

  private async getEvaluaciones(){
    const data = await this.service.getEvaluaciones(this.idPlantilla);
    const info = CommonVariables.obtenerPeriodos([].concat(data.evaluaciones), this.numEvaluaciones);

    this.header.title = await this.translate.instant('liquidez.gap.tituloTabla');
    this.periodos = info.periodos;

    this.getCadenaEvaluacion();
  }

  private getCadenaEvaluacion(){    
    this.cadenaEvaluacion = this.periodos.flatMap(y => {
      return y.series
      .filter(m => m.check)
      .map(m => {
        return {
          text: m.periodo,
          id: m.id
        }
      })
    });
    this.header.subtitles = this.cadenaEvaluacion;
    this.header = {...this.header};
    this.getData();
  }

  async getData(){
    const per = this.perspectivas.find(p => p.check );
    this.header.title = per.nombre;
    const configuracion = this.templateLoader.obtenerConfiguracionRazones(this.idAdmin, per.name);
    if(configuracion.filas){
      configuracion.id = this.idAdmin;
      const  tabla = await this.tableroService.getTabla(
        configuracion,
        this.cadenaEvaluacion,
        this.idPlantilla
      );
      this.tablaConfig = tabla;
      this.verTabla = true;
    }else{
      messages.infoMessageGraph(configuracion);
    }
  }

  showAndHide(fila){
    const filas = this.tablaConfig.filas;
    const filter = filas.filter(f => fila.sumar.includes(f.id));
    
    filter.forEach(f =>{
      f.visible = !f.visible;
    });
    
    fila.expandido = !fila.expandido;
  }

  cambioPeriodo(per){
    for(const an of this.periodos){
      for(const mes of an.series){
        if(mes.periodo === per.periodo){
          mes.check = true;
        }else{
          mes.check = false;
        }
      }
    }
    this.periodos = [...this.periodos];
    this.getCadenaEvaluacion();
  }

  cambioPerspectiva(per: {nombre: string, name: string, check: boolean}){
    this.perspectivas.forEach( p => {
      p.check = p.name === per.name;
    });
    this.getData()
  }
  
  exportExcel(){
    messages.messageSaving(this.translate.instant('swal.generando'), this.translate.instant('swal.espere'))
    var titulos = [], alineacion = [], formato = [], data = [], tipo = [];
    var tituloHoja = '', nombreArch = '';

      alineacion = [
        Aligment.LEFT,
        ...this.tablaConfig.filas[0].bandas.map(f => {return Aligment.RIGHT}),
      ];
      formato = [
        FormatText.TEXT,
        ...this.tablaConfig.filas[0].bandas.map(f => {return FormatText.NUMBERDEC}),
      ];
      this.tablaConfig.columnas.forEach(h =>{
        titulos.push(h)
      });
      this.tablaConfig.filas.forEach( f => { 
        const aux = [];
        const auxT = [];
        
        auxT.push(f.type === 'subtotal' || f.type === 'titulo' || f.suma?TypeRow.TOTAL:TypeRow.NORMAL);
        aux.push(f.descripcion);

        if(f.bandasValue){
          f.bandasValue.forEach(v => {
            auxT.push(f.type === 'subtotal' || f.type === 'titulo' || f.suma?TypeRow.TOTAL:TypeRow.NORMAL);
            aux.push(v ?? '');
          });
        }else {
          f.bandas.forEach(v => {
            auxT.push(f.type === 'subtotal' || f.type === 'titulo' || f.suma?TypeRow.TOTAL:TypeRow.NORMAL);
            aux.push('');
          });
        }
        
        tipo.push(auxT);
        data.push(aux);
      });

    const per = this.perspectivas.find(p => p.check );
    tituloHoja = per.nombre;
    nombreArch = 'riesgo_liquidez';

    this.excelService.generateExcel(tituloHoja, titulos, data, nombreArch, alineacion, formato, tipo);
    messages.succesMessageGraph(this.translate.instant('swal.descargaExi'));
  }
}
